import React from 'react';
import { Overlay } from '@ui';

const TooltipModal = ({ elementRef, customRender, onDismiss }) => {
  const _handleOverlayClick = () => {
    onDismiss();
  };

  return <Overlay onDismiss={_handleOverlayClick}>{customRender}</Overlay>;
};

export default TooltipModal;
